"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowButtonTextEditor = /** @class */ (function (_super) {
    __extends(CardRowButtonTextEditor, _super);
    function CardRowButtonTextEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.GRID_CARD_CSS = { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px" };
        return _this;
    }
    CardRowButtonTextEditor.prototype.onValueChange = function (e) {
        if (this.props.onValueChanged) {
            this.props.onValueChanged(e.target.value);
        }
    };
    CardRowButtonTextEditor.prototype.onButtonClick = function () {
        if (this.props.onButtonClick) {
            this.props.onButtonClick();
        }
    };
    CardRowButtonTextEditor.prototype.getRequiredMark = function () {
        if (this.props.required) {
            return (React.createElement("div", { style: { color: "#FF0000", marginRight: "2px" } }, "*"));
        }
        return (null);
    };
    CardRowButtonTextEditor.prototype.getErrorMessage = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return (React.createElement("div", { style: { color: "#FF0000", fontSize: "10px", textAlign: "left" } }, this.props.rules.errorMessage));
            }
        }
        return null;
    };
    CardRowButtonTextEditor.prototype.getDescriptionMessage = function () {
        if (this.props.texts.description) {
            return (React.createElement("div", { style: { color: "#0000FF", fontSize: "10px", textAlign: "left" } }, this.props.texts.description));
        }
        return null;
    };
    CardRowButtonTextEditor.prototype.getCSSStyle = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return { borderColor: "#FF0000", borderStyle: "solid", borderWidth: "1px", borderRadius: "4px" };
            }
        }
        return null;
    };
    CardRowButtonTextEditor.prototype.getInputRenderObject = function () {
        if (this.props.texts.caption) {
            return (React.createElement(antd_1.Input, { addonBefore: React.createElement("div", { style: { width: "200px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", lineHeight: "30px" } },
                    this.getRequiredMark(),
                    React.createElement("div", null, this.props.texts.caption)), placeholder: this.props.texts.placeholder, value: this.props.value, onChange: this.onValueChange.bind(this), disabled: this.props.disabled, readOnly: this.props.readonly, addonAfter: React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.texts.buttonHint), trigger: "hover" },
                    React.createElement(antd_1.Button, { disabled: this.props.disabled, type: "primary", size: "small", shape: "circle", icon: this.props.buttonIcon, ghost: true, onClick: this.onButtonClick.bind(this) })), style: this.getCSSStyle() }));
        }
        else {
            return (React.createElement(antd_1.Input, { placeholder: this.props.texts.placeholder, value: this.props.value, onChange: this.onValueChange.bind(this), disabled: this.props.disabled, readOnly: this.props.readonly, addonAfter: React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.texts.buttonHint), trigger: "hover" },
                    React.createElement(antd_1.Button, { disabled: this.props.disabled, type: "primary", size: "small", shape: "circle", icon: this.props.buttonIcon, ghost: true, onClick: this.onButtonClick.bind(this) })), style: this.getCSSStyle() }));
        }
    };
    CardRowButtonTextEditor.prototype.render = function () {
        return (React.createElement(antd_1.Card.Grid, { style: this.GRID_CARD_CSS },
            this.getDescriptionMessage(),
            this.getInputRenderObject(),
            this.getErrorMessage()));
    };
    return CardRowButtonTextEditor;
}(React.Component));
exports.default = CardRowButtonTextEditor;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/editors/CardRowButtonTextEditor.tsx
// module id = 45
// module chunks = 0